import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { APISettings } from '../../misc/settings';
import { User, Question } from 'src/app/models/ui/User';
import { ProviderParameters, BankDetailParameters } from 'src/app/models/ui/ProviderParameters';
import { AccountDetailsParameters } from 'src/app/models/ui/AccountDetailsParameters';
import { GetCommand } from 'src/app/models/ui/CommandParameters';
import { CodeSetDto } from 'src/app/models/ui/CodeSetDto';
import { CodeSetWithExcluded } from 'src/app/models/ui/CodeSetWithExcluded';

@Injectable({
  providedIn: 'root'
})
export class LookupService {

  command: GetCommand;

  constructor(private http: HttpClient) { this.command = new GetCommand(); }

  getProviders(): Observable<any[]>{
    this.command.Command = "GET";
    return this.http.post<any[]>(`${APISettings.apiBaseAddress}/api/providers/getall`, this.command, APISettings.httpOptions);
  }

  getPendingProviders(): Observable<any[]>{
    this.command.Command = "GET";
    return this.http.post<any[]>(`${APISettings.apiBaseAddress}/api/providers/getpending`, this.command, APISettings.httpOptions);
  }

  getRejectedProviders(): Observable<any[]>{
    this.command.Command = "GET";
    return this.http.post<any[]>(`${APISettings.apiBaseAddress}/api/providers/getrejected`, this.command, APISettings.httpOptions);
  }

  getSuspendedProviders(): Observable<any[]>{
    this.command.Command = "GET";
    return this.http.post<any[]>(`${APISettings.apiBaseAddress}/api/providers/getsuspended`, this.command, APISettings.httpOptions);
  }

  getApprovedProviders(): Observable<any[]>{
    this.command.Command = "GET";
    return this.http.post<any[]>(`${APISettings.apiBaseAddress}/api/providers/getapproved`, this.command, APISettings.httpOptions);
  }

  getProvider(): Observable<ProviderParameters> {
    this.command.Command = "GET";
    this.command.ProviderId = localStorage.getItem("currentProvider");
    return this.http.post<ProviderParameters>(`${APISettings.apiBaseAddress}/api/providers/getprovider`, this.command, APISettings.httpOptions);
  }

  getBankDetails(Id: number): Observable<BankDetailParameters> {
    this.command.Command = "GET";
    this.command.BankId = Id;
    return this.http.post<BankDetailParameters>(`${APISettings.apiBaseAddress}/api/lookup/getbankdetails`, this.command, APISettings.httpOptions);
  }

  getAccount(): Observable<AccountDetailsParameters> {
    this.command.Command = "GET";
    return this.http.post<AccountDetailsParameters>(`${APISettings.apiBaseAddress}/api/lookup/getaccount`, this.command, APISettings.httpOptions);
  }

  getUsers(): Observable<any[]>{
    this.command.Command = "GET";
    return this.http.post<any[]>(`${APISettings.apiBaseAddress}/api/lookup/getusers`, this.command, APISettings.httpOptions);
  }

  getUsersByProvider(): Observable<any[]>{
    this.command.Command = "GET";
    this.command.ProviderId = localStorage.getItem("currentProvider");
    return this.http.post<any[]>(`${APISettings.apiBaseAddress}/api/lookup/getusersbyprovider`, this.command, APISettings.httpOptions);
  }

  getUser() : Observable<User> {
    this.command.Command = "GET";
    this.command.UserName = localStorage.getItem("loggedUsername");
    return this.http.post<User>(`${APISettings.apiBaseAddress}/api/lookup/getuser`, this.command, APISettings.httpOptions);
  }

  getQuestions(username: string) : Observable<Question> {
    this.command.Command = "GET";
    this.command.UserName = username;
    return this.http.post<Question>(`${APISettings.apiBaseAddress}/api/lookup/getquestions`, this.command, APISettings.httpOptions);
  }

  getContractTypes(): Observable<any[]>{
    this.command.Command = "GET";
    return this.http.post<any[]>(`${APISettings.apiBaseAddress}/api/lookup/getcontracttypes`, this.command, APISettings.httpOptions);
  }

  getRoles(): Observable<any[]>{
    this.command.Command = "GET";
    return this.http.post<any[]>(`${APISettings.apiBaseAddress}/api/lookup/getroles`, this.command, APISettings.httpOptions);
  }

  getDOHRoles(): Observable<any[]>{
    this.command.Command = "GET";
    return this.http.post<any[]>(`${APISettings.apiBaseAddress}/api/lookup/getdohroles`, this.command, APISettings.httpOptions);
  }

  getProviderRoles(): Observable<any[]>{
    this.command.Command = "GET";
    return this.http.post<any[]>(`${APISettings.apiBaseAddress}/api/lookup/getproviderroles`, this.command, APISettings.httpOptions);
  }

  getStatus(): Observable<any[]>{
    this.command.Command = "GET";
    return this.http.post<any[]>(`${APISettings.apiBaseAddress}/api/lookup/getstatus`, this.command, APISettings.httpOptions);
  }

  getCountries(): Observable<any[]>{
    this.command.Command = "GET";
    return this.http.post<any[]>(`${APISettings.apiBaseAddress}/api/lookup/getcountries`, this.command, APISettings.httpOptions);
  }

  getProcedureCodesets(): Observable<any[]>{
    this.command.Command = "GET";
    this.command.ProviderId = localStorage.getItem("currentProvider");
    return this.http.post<any[]>(`${APISettings.apiBaseAddress}/api/codeset/getproceduresets`, this.command, APISettings.httpOptions);
  }

  getDiagnosisCodesets(): Observable<any[]>{
    this.command.Command = "GET";
    this.command.ProviderId = localStorage.getItem("currentProvider");
    return this.http.post<any[]>(`${APISettings.apiBaseAddress}/api/codeset/getdiagnosissets`, this.command, APISettings.httpOptions);
  } 

  getCodeSets(type: number): Observable<CodeSetWithExcluded>{
    return this.http.get<CodeSetWithExcluded>(`${APISettings.apiBaseAddress}/api/codeset/getCodeSets/codeSetsService?type=${type}&providerId=${localStorage.getItem("currentProvider")}`);
  } 

  getDentalCodesets(): Observable<any[]>{
    this.command.Command = "GET";
    this.command.ProviderId = localStorage.getItem("currentProvider");
    return this.http.post<any[]>(`${APISettings.apiBaseAddress}/api/codeset/getdentalsets`, this.command, APISettings.httpOptions);
  }

  getDrugCodesets(): Observable<any[]>{
    this.command.Command = "GET";
    this.command.ProviderId = localStorage.getItem("currentProvider");
    return this.http.post<any[]>(`${APISettings.apiBaseAddress}/api/codeset/getdrugsets`, this.command, APISettings.httpOptions);
  }

  getCurrencies(): Observable<any[]>{
    this.command.Command = "GET";
    return this.http.post<any[]>(`${APISettings.apiBaseAddress}/api/lookup/getcurrencies`, this.command, APISettings.httpOptions);
  }

  getTimezones(): Observable<any[]>{
    this.command.Command = "GET";
    return this.http.post<any[]>(`${APISettings.apiBaseAddress}/api/lookup/gettimezones`, this.command, APISettings.httpOptions);
  }

  getUserRole(user: User): Observable<string>{
    this.command.Command = "GET";
    this.command.UserName = user.UserName;
    return this.http.post<string>(`${APISettings.apiBaseAddress}/api/lookup/getuserrole`, this.command, APISettings.httpOptions);
  }

  getClemittanceToken(user: User): Observable<User>{
    return this.http.post<User>(`${APISettings.clemittanceBaseAddress}/api/webtoken/generate`, user, APISettings.httpOptions);
  }

  getDefault(): any[] {
    return [
      {
        bit: true,
        Name: 'Yes'
      },
      {
        bit: false,
        Name: 'No'
      }
    ];
  }
}